const {Component} = require("react");
const PropTypes = require("prop-types");
const Stars = require("components/mixins/Stars");
const {methodNotImplemented} = require("helpers/errors");
const {classList} = require("helpers/html");

class Rating extends Component {

	static get propTypes() {
		return {
			value: PropTypes.any,
			max: PropTypes.number,
			interactive: PropTypes.bool,
			handleChange: PropTypes.func
		};
	}

	static get defaultProps() {
		return {
			max: 5,
			interactive: true
		}
	}

	constructor(props) {
		super(props);

		this.state = {
			value: this.normalizeValue(props.value),
			fill: 0
		};
	}

	componentWillReceiveProps(props) {
		if (props.value !== this.state.value) {
			this.setState({value: props.value});
		}
	}

	get className() {
		return classList("rating-selector", this.props.interactive ? "interactive" : false, this.props.className);
	}

	normalizeValue(value) {
		if (typeof value !== "number") {
			return;
		}

		if (value < 1) {
			return 1;
		}

		if (value > this.props.max) {
			return this.props.max;
		}

		return value;
	}

	handleChange = () => {
		if (typeof this.props.handleChange === "function") {
			this.props.handleChange(this.state.value);
		}
	};

	onMouseOver(i) {
		return () => {
			this.setState({fill: i})
		};
	}

	onMouseOut() {
		return () => {
			this.setState({fill: 0});
		};
	}

	onClick(i) {
		return () => {
			this.setState({value: i}, this.handleChange);
		};
	}

	computeStarProps = (i) => {
		return this.props.interactive ? {
			onMouseOver: this.onMouseOver(i),
			onMouseOut: this.onMouseOut(),
			onClick: this.onClick(i)
		} : {};
	};

	renderStars() {
		const filled = Math.max(this.state.value || 0, this.state.fill);

		return (
			<Stars total={this.props.max} filled={filled} starProps={this.computeStarProps}/>
		);
	}

	render() {
		throw methodNotImplemented("render");
	}

}

module.exports = Rating;


// WEBPACK FOOTER //
// ./resources/js/components/abstract/Rating.js